/**
 * Enum representing different severities for PrimeNG Tag components.
 *
 * @usageNotes
 * The `PrimeNGTagSeverity` enum defines constants for different severities
 * that can be used with PrimeNG Tag components, such as PRIMARY, SUCCESS, INFO, WARNING, and DANGER.
 *
 * @see https://primeng.org/tag#severity
 */
export enum PrimeNGTagSeverity {
    INFO = 'info',
    SUCCESS = 'success',
    WARN = 'warn',
    DANGER = 'danger',
    SECONDARY = 'secondary',
    CONTRAST = 'contrast',
}
